<template>
  <v-app id="inspire" class="bodyPadding"> 
    <mo-header></mo-header>
    <v-content>
		<vehicle-head></vehicle-head>		
		<vehicle-list></vehicle-list>
    </v-content>
  </v-app>
</template>

<script>

	import VehicleHead from './Header.vue';	
	import VehicleList from './List.vue';
	export default {
		data () {
			return {
		
			}		
		},
		components: {
          VehicleHead,			
          VehicleList
		}
	}
</script>

<style scoped>
	@import '../../shared/assets/css/shared.css'
</style>